/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Button_Creating_AccountInputs */

const es_co2_signup_button_creating_account = /** @type {(inputs: Signup_Button_Creating_AccountInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creando cuenta…`)
};

/**

* @param {Signup_Button_Creating_AccountInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_button_creating_account = /** @type {((inputs?: Signup_Button_Creating_AccountInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Button_Creating_AccountInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_button_creating_account(inputs)
});